export const TECHNOLOGIES_RECEIVED = 'TECHNOLOGIES_RECEIVED';
export const TECHNOLOGIES_STARTED = 'TECHNOLOGIES_STARTED';
